export default __webpack_public_path__ + "_/shared_modules/base-layout/img/yts-logo-086a1a16850b4477b1c85e24975815df.png";